<template>
    <div class="loading-spinner-wrapper">
        <fulfilling-square-spinner
            :animation-duration="2500"
            :size="30"
            :color="color"
        />
    </div>
</template>

<script>
    import { FulfillingSquareSpinner } from 'epic-spinners'

    export default {
        name: "loading-spinner",
        components: {
            FulfillingSquareSpinner
        },
        props: {
            color: {
                type: String,
                default: '#455F86'
            },
        }
    }
</script>

<style scoped>
    .loading-spinner-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
